import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from '@/router';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import { loadFonts } from '@/plugins/webfontloader';

import 'typeface-roboto/index.css';
import '@/service-worker';

const app = createApp(App);

app.use(vuetify);
app.use(createPinia());
app.use(router);

loadFonts().then(() => {
  app.mount('#app');
  console.log(`${new Date().toLocaleString()} : Page loaded`);
});
